import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_471: DocMigration = {
  maxSchemaVersion: "0.0.471",
  description: "Rename perspective viewport camera keys",
  apply(json: any) {
    const {
      viewports = {},
      localParameters = {},
      globalParameters = {},
      contentTemplateInstances = {},
      planSetTemplateConfigs = {},
    } = json;

    const viewportIds = Object.keys(viewports);
    for (const viewportId of viewportIds) {
      const viewport = viewports[viewportId];
      if (viewport.viewType !== "VIEW_3D") {
        continue;
      }
      if (typeof viewport.contentSourceId !== "string") {
        continue;
      }
      viewport.contentSourceId = migrateView3DId(viewport.contentSourceId);
    }

    for (const paramId in localParameters) {
      const param = localParameters[paramId];
      if (param.type === "VIEW_3D") {
        param.defaultValue = migrateView3DId(param.defaultValue);
      }
    }

    for (const paramId in globalParameters) {
      const param = globalParameters[paramId];
      if (param.type === "VIEW_3D") {
        param.defaultValue = migrateView3DId(param.defaultValue);
      }
    }

    for (const templateId in contentTemplateInstances) {
      const template = contentTemplateInstances[templateId];
      migrateParameterValueTable(template.parameterValues ?? {}, localParameters);
    }

    for (const templateId in planSetTemplateConfigs) {
      const template = planSetTemplateConfigs[templateId];
      migrateParameterValueTable(template.parameterValues ?? {}, localParameters);
      migrateParameterValueTable(template.globalParameterValues ?? {}, globalParameters);
    }

    return json;
  },
};

function migrateParameterValueTable(parameterValues: { [paramId: string]: any }, parameters: any) {
  for (const paramId in parameterValues) {
    if (!parameters[paramId]) {
      continue;
    }
    if (parameters[paramId].type !== "VIEW_3D") {
      continue;
    }
    const paramValue = parameterValues[paramId];
    if (paramValue && paramValue.type === "PRIMITIVE") {
      paramValue.value = migrateView3DId(paramValue.value);
      continue;
    }
  }
}

function migrateView3DId(contentSourceId: string) {
  if (contentSourceId === "topLeftPerspectiveCamera") {
    return "frontLeftAerial";
  }
  if (contentSourceId === "topRightPerspectiveCamera") {
    return "frontRightAerial";
  }
  if (contentSourceId === "bottomLeftPerspectiveCamera") {
    return "backLeftAerial";
  }
  if (contentSourceId === "bottomRightPerspectiveCamera") {
    return "backRightAerial";
  }
  if (contentSourceId === "defaultExteriorCamera") {
    return "frontSidewalk";
  }
  return contentSourceId;
}

export default migration_0_0_471;
